import { ReportDetails } from 'models/api/report';
import Table from 'models/api/table';
import Id from 'models/id';

export const reportDetailsToWorkplace = (items: Table<ReportDetails>) => ({
    rowsCount: items.rowsCount,
    data: items.data.map((item, index) => {
        const newItem: Id & ReportDetails = {
            ...item,
        };

        newItem.id = ('id' in item ? item.id : index).toString();
        return newItem;
    }),
});
